export default {
  title: 'Stav migrácie {type}',
  confirmReset: {
    header: 'Resetovať stav migrácie {count} {type}?',
    message: 'Všetky {type} sa znova migrujú od prvých dostupných údajov v PT9800.',
  },
};
